import { jsx as _jsx } from "react/jsx-runtime";
import { DividerContainer } from "./styled";
export const Divider = props => _jsx(DividerContainer, { ...props });
